var exports = {
  "f": "DMListPageItems.module__accent___cnRmd2" + " " + __webpack_require__(367917)["LU"],
  "og": "DMListPageItems.module__accentIcon___cnRmd2",
  "Fv": "DMListPageItems.module__accentLabel___cnRmd2",
};

module.exports = exports;
